import { ILoginRequest } from "../../../model/request/auth/ILoginRequest";
import { ILoginVnptRequest } from "../../../model/request/auth/ILoginVnptRequest";
import { ILoginNamVietRequest } from "../../../model/request/auth/ILoginNamVietRequest";
import { ILoginRespone } from "../../../model/respone/auth/ILoginRespone";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

/** Payload khi đổi mật khẩu thành công — JWT mới (đã bỏ pwd_must_change) để thay token. */
export interface IPasswordChangedPayload {
    access_token: string;
    expires_at: string;
}

export const eAuthActionTypeDefine = {
    LOGIN_START: {} as ILoginRequest,
    LOGIN_VNPT_START: {} as ILoginVnptRequest,
    LOGIN_NAMVIET_START: {} as ILoginNamVietRequest,
    LOGIN_SUCCESS: {} as ILoginRespone,
    LOGIN_ERROR: "" as string,
    LOGOUT: undefined as undefined,
    RESTORE_SESSION: {} as ILoginRespone,
    PASSWORD_CHANGED: {} as IPasswordChangedPayload,
};

export const eAuthActionTypeIds = generateActionTypeIds(eAuthActionTypeDefine, "AUTH");

export type IAuthActions = IGenericActionType<typeof eAuthActionTypeDefine, "AUTH">;
